import { Box, Button } from "@mui/material";
import styled from "styled-components";

export const PetDetailsStyled = styled(Box)`
  .main-wrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    svg {
      width: 100%;
      height: auto;
    }
  }
`;

export const AddPetDetailsStyled = styled(Box)`
  &.form {
    display: flex;
    flex-direction: column;
    row-gap: 16px;
  }
`;

export const PetCardStyled = styled.div`
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 16px;
  cursor: pointer;

  &.isSelected {
    border: 2px solid #2460b8;
    background-color: #f0f8ff;
  }
  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    flex-wrap: wrap;
    row-gap: 10px;
    > div {
      margin-right: 16px;
    }
  }

  .row2 {
    display: flex;
    gap: 80px;

    > div {
      display: flex;
      flex-direction: column;
    }
  }

  .label {
    font-weight: bold;
    font-size: 14px;
    color: #555;
    margin-bottom: 4px;
  }

  .value {
    font-size: 14px;
    color: #333;
  }
`;

export const PetsListStyled = styled(Box)`
  overflow-y: auto;
  height: calc(100vh - 400px);
`;

export const AddPetButtonStyled = styled(Button)`
  white-space: nowrap;
  min-width: 140px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  padding-left: 24px;
  padding-right: 24px;
`;